// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle-pageTitle-1kL","pageTitleHasChildren":"PageTitle-pageTitleHasChildren-3Ft"};